import './style.scss';
import type ValidationInfo from '../../../../validation/validation-info';
import { TranslationService } from '../../../../services/translation.service';
import SelectableSquare from '../SelectableSquare';
import carIconBasic from '../../../../../assets/icons/price-calculator/car-basic-default-blue-1000.svg';
import carIconNormal from '../../../../../assets/icons/price-calculator/car-normal-default-blue-1000.svg';
import carIconLarge from '../../../../../assets/icons/price-calculator/car-large-default-blue-1000.svg';
import carIconPremium from '../../../../../assets/icons/price-calculator/car-premium-default-blue-1000.svg';
import { CarType } from '../../models/car-type.enum';
import RequiredAsterisk from '../../../Shared/RequiredAsterisk';

interface ICarTypeSelectorState {
  value: CarType | undefined;
  validationInfo: ValidationInfo;
}

interface CarTypeSelectorProps {
  id: string;
  labelText: string;
  state: ICarTypeSelectorState;
  onChange?: (value: CarType) => void;
}

function CarTypeSelector({ id, labelText, state, onChange }: CarTypeSelectorProps) {
  const options: { value: CarType; icon: string; title: string; text: string }[] = [
    { value: CarType.Basic, icon: carIconBasic, title: TranslationService.get('pricecalculatorpage.cartype.basic'), text: TranslationService.get('pricecalculatorpage.cartype.basictext') },
    { value: CarType.Normal, icon: carIconNormal, title: TranslationService.get('pricecalculatorpage.cartype.normal'), text: TranslationService.get('pricecalculatorpage.cartype.normaltext') },
    { value: CarType.Large, icon: carIconLarge, title: TranslationService.get('pricecalculatorpage.cartype.large'), text: TranslationService.get('pricecalculatorpage.cartype.largetext') },
    { value: CarType.Premium, icon: carIconPremium, title: TranslationService.get('pricecalculatorpage.cartype.premium'), text: TranslationService.get('pricecalculatorpage.cartype.premiumtext') },
  ];

  return (
    <div className="car-type-selector mb-3">
      <div className="d-inline-block fw-bold car-type-selector__label">
        {labelText ?? ''}
        <RequiredAsterisk />
      </div>
      <div id={id} className="car-type-selector__options">
        {options.map((option) => (
          <SelectableSquare
            key={option.value}
            icon={option.icon}
            name="car-type-radio"
            title={option.title}
            className={state.validationInfo.isInvalid ? 'is-invalid' : ''}
            text={option.text}
            checked={state.value === option.value}
            onChange={() => onChange?.(option.value)}
          />
        ))}
      </div>
      {state.validationInfo.isInvalid && (
        <div className="invalid-feedback d-block">
          {state.validationInfo.errors.map((error) => (
            <div key={error}>{error}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CarTypeSelector;

